import styled from "styled-components";
import { Link } from "react-router-dom";

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const StyledLink = styled(Link)`
  color: ${({ theme }) => theme.pallette.white.main};
  margin: 0;
  padding: 0;
  font-style: normal;
  font-weight: 500;
  font-size: ${({ theme }) => theme.fontSizes[2]}px;
  line-height: 20px;
  transition: all 0.5s ease;

  &:hover {
    color: ${({ theme }) => theme.pallette.blue.light};
  }
`;

export const StyledButton = styled(Link)`
  height: ${({ theme }) => theme?.buttons?.startHere?.height};
  display: flex;
  padding: ${({ theme }) => theme?.buttons?.startHere?.padding};
  align-items: center;
  gap: 8px;
  font-style: normal;
  font-weight: ${({ theme }) => theme?.buttons?.startHere?.weight};
  line-height: ${({ theme }) => theme?.buttons?.startHere?.lineHeight};
  letter-spacing: 0.3px;
  font-size: ${({ theme }) => theme?.buttons?.startHere?.fontSize};
  background: ${({ theme }) => theme?.buttons.startHere?.background};
  border-radius: ${({ theme }) => theme?.buttons.main?.radius};
  box-shadow: ${({ theme }) => theme?.buttons?.main?.shadow};
  color: ${({ theme }) => theme?.buttons?.startHere?.color};
  border: 1px solid ${({ theme }) => theme?.buttons?.startHere?.border};

  svg {
    path {
      stroke: ${({ theme }) => theme?.buttons?.startHere?.color};
    }
  }

  &:hover {
    border: 1px solid ${({ theme }) => theme?.buttons?.startHere?.hover?.border};
    color: ${({ theme }) => theme?.buttons?.startHere?.hover?.color};
    background: ${({ theme }) => theme?.buttons?.startHere?.hover?.background};

    svg {
      path {
        stroke: ${({ theme }) => theme?.buttons?.startHere?.hover?.color};
      }
    }
  }
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0 24px;
`;
